// tab 박스 토글
const tboxActive = (element) => {
  const tabBox = document.querySelectorAll(".tab-box");
  const currentSpace = window.innerHeight - document.querySelector('.drmvsn-pdp-info').getBoundingClientRect().bottom - 15 - 20 > 70 ? window.innerHeight - document.querySelector('.drmvsn-pdp-info').getBoundingClientRect().bottom - 15 - 20 : 70
  document.documentElement.style.setProperty('--tabbox-max-height', `${currentSpace}px`);
  if (element.parentElement.className.indexOf("opened") < 0) {
    for (var i = 0; i < tabBox.length; i++) {
      tabBox[i].classList.remove("opened");
    }
    element.parentElement.classList.add("opened");
  } else {
    for (var i = 0; i < tabBox.length; i++) {
      tabBox[i].classList.remove("opened");
    }
  }
}


document.addEventListener('DOMContentLoaded', function(){

  if(document.querySelector('panagora-raffle-container')) {
    //라플상품
    document.querySelector('.drmvsn-pdp-container').classList.add('raffle-prd');
    //로그인 했을때 상품정보 노출
    if(document.querySelector('panagora-raffle-form')) document.querySelector('#product-add-info').style.display = 'block'; 
  }else {
  document.querySelector('#product-add-info').style.display = 'block';
  }

  
/*라플 상품일때만 desc 위치 변경하기*/
  const targetSelector = document.querySelector('#raffle-desc-parents');
  const sourceSelector = document.querySelector('.raffle-description');
  if(!targetSelector || !sourceSelector) return;
  function moveOnce(){
    const src = document.querySelector(sourceSelector);
    const dst = document.querySelector(targetSelector);
    if (src && dst && !dst.contains(src)) {
      dst.appendChild(src);
      return true;
    }
    return false;
  }

  // 먼저 한 번 시도
  if (moveOnce()) return;

  // 이후 동적 삽입에 대비
  const obs = new MutationObserver(() => {
    if (moveOnce()) obs.disconnect();
  });
  obs.observe(document.body, { childList:true, subtree:true });
  
});


